// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';

const UpdateBank = () => {
  return (
    <EditEntity
      pageTitle="EditBank"
      fetchApiUrl="/api/v1/web_portal/settlements/banks/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={[
        {
          name: 'bank_name_en',
          labelKey: 'BankNameEn',
          inputType: 'text',
          required: true,
        },
        {
          name: 'bank_name_ar',
          labelKey: 'BankNameAr',
          inputType: 'text',
          required: true,
        },
        {
          name: 'swift_code',
          labelKey: 'SwiftCode',
          inputType: 'text',
          required: true,
        },
      ]}
      dropdowns={[]}
      updateApiUrl="/api/v1/web_portal/settlements/banks/:id"
      updateApiMethod="PATCH"
      buildUpdatePayload={(formValues, params, entityData) => {
        return {
          bank_name_en: formValues.bank_name_en?.trim(),
          bank_name_ar: formValues.bank_name_ar?.trim(),
          swift_code: formValues.swift_code?.trim(),
        };
      }}
      backUrl="/settlements/Banks/:id"
      successMessage="UpdatedSuccessfully"
      updateButtonLabel="update"
    />
  );
};

export default UpdateBank;
